<template>
  <p :class="inClass" class="keep-spaces">
    {{nameDisplay}}
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="grey"
          dark
          v-bind="attrs"
          v-on="on" v-if="name.length>widthAvailable">
          mdi-dots-horizontal
        </v-icon>
      </template>
      <span>{{name}}</span>
    </v-tooltip>
  </p>
  
</template>

<script>
export default {
  props:{
    name:{
      type: String,
      default: ""
    },
    widthAvailable:{
      type: Number,
      default:0
    },
    inClass:{
      type:String,
      default:""
    }
  },
  computed:{
    nameDisplay:{
      get(){
        if(this.name.length <= this.widthAvailable )
          return this.name
        else return this.name.substring(0,this.widthAvailable)     
      }
    }
  },
}
</script>

<style scoped>
 .keep-spaces { 
   white-space: pre-wrap; 
  }
</style>